var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('vs-button',{attrs:{"type":"border","color":"danger","icon-pack":"feather","icon":"icon-trash","size":"small"},on:{"click":function($event){return _vm.openConfirm()}}},[_vm._v("Delete")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }